import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'

const Tip = props => {
  // Detect small phone
  const isSmallPhone = window.innerHeight < 700;

  return (
    <div style={{
      backgroundColor: 'white',
      height: '100vh',
      color: '#333',
      paddingBottom: 'max(20px, env(safe-area-inset-bottom, 0px))',
      paddingTop: isSmallPhone ? '10px' : '0',
      display: 'flex',
      flexDirection: 'column'
    }}>
    	<Row style={{height: isSmallPhone ? '2vh' : '8vh'}} />

    	<Row>
        {
          (props.storeId == 0 || props.tipOnlyMode) ? (
            <></>
          ) : (
            <div style={{color: '#333', fontSize: isSmallPhone ? '24px' : '36px', textAlign: 'center'}}>Balance Due {props.fiatSymbol || '$'}{ props.total().toFixed(2) }</div>
          )
        }
    		<div style={{color: '#333', fontSize: isSmallPhone ? '20px' : '30px', textAlign: 'center'}}>
          {props.tipOnlyMode ? 'Select Tip Amount' : 'Would you like to leave a tip?'}
        </div>
    	</Row>
    	<Row style={{height: isSmallPhone ? '15px' : '56px'}} />

    	<Row>
    		<Col sm={{span: 1}}/>
    		<Col sms={{span: 10}}>
    			<Row>
            {
              (
                (props.storeId == 0 || props.tipOnlyMode) ? [
                  {tipId: 'tip-5-flat', tipText: (props.fiatSymbol || '$')+'5.00'},
                  {tipId: 'tip-10-flat', tipText: (props.fiatSymbol || '$')+'10.00'},
                  {tipId: 'tip-20-flat', tipText: (props.fiatSymbol || '$')+'20.00'},
                ] : [
                  {tipId: 'tip-25', tipText: '25%', tipMath: (props.fiatSymbol || '$') + (props.total() * 1.25).toFixed(2)},
                  {tipId: 'tip-20', tipText: '20%', tipMath: (props.fiatSymbol || '$') + (props.total() * 1.20).toFixed(2)},
                  {tipId: 'tip-18', tipText: '18%', tipMath: (props.fiatSymbol || '$') + (props.total() * 1.18).toFixed(2)},
                ]
              ).map((tip, index) => (
    				<Col key={index} style={{padding: '5px', margin: '0px', fontSize: isSmallPhone ? '24px' : '36px', textAlign: 'center', borderRadius: '4px'}} sm={{span: 4}}>
    					<div style={{backgroundColor: (props.tipSelect == tip.tipId ? '#1E3A8A' : 'black'), color: 'white', borderRadius: '4px', padding: isSmallPhone ? '8px 0' : '12px 0'}} onClick={()=>props.handleTip(tip.tipId)}>
    						<Row><Col style={{fontSize: isSmallPhone ? '4vh' : '5vh', textAlign: 'center'}}>{tip.tipText}</Col></Row>
    						<Row><Col style={{fontSize: isSmallPhone ? '16px' : '21px', textAlign: 'center'}}>{tip.tipMath}</Col></Row>
    					</div>
    				</Col>
                )
              )
            }
    			</Row>
    		</Col>
    		<Col sm={{span: 1}}/>
    	</Row>

    	<Row style={{marginTop: isSmallPhone ? '5px' : '0'}}>
    		<Col sm={{span: 1}} />
    		<Col sms={{span: 10}}>
    			<Row>
            {
              <Col style={{padding: '5px', margin: '0px', fontSize: isSmallPhone ? '16px' : '21px', textAlign: 'center'}}>
                <div style={{backgroundColor: (props.tipSelect == 'tip-cust' ? '#1E3A8A' : 'black'), color: 'white', borderRadius: '4px', padding: isSmallPhone ? '8px 0' : '12px 0'}} onClick={()=>props.handleTip('tip-cust')}>
                  <Row><Col>Custom tip {props.fiatSymbol || '$'}{props.customTip ? props.customTip.toFixed(2) : ''}</Col></Row>
                </div>
              </Col>
            }
            {
              (props.storeId == 0 || props.tipOnlyMode) ? (
                <></>
              ) : (
    						<Col style={{padding: '5px', margin: '0px', fontSize: isSmallPhone ? '16px' : '21px', textAlign: 'center'}}>
    							<div style={{backgroundColor: (props.tipSelect == 'tip-no' ? '#1E3A8A' : 'black'), color: 'white', borderRadius: '4px', padding: isSmallPhone ? '8px 0' : '12px 0'}} onClick={()=>props.handleTip('tip-no')}>
    								<Row><Col>No tip</Col></Row>
    							</div>
    						</Col>
              )
            }
    			</Row>
    		</Col>
    		<Col sm={{span: 1}} />
    	</Row>

    	<Row style={{flex: 1, minHeight: isSmallPhone ? '10px' : '8vh'}} />

    	<Row style={{height: isSmallPhone ? '50px' : '80px', lineHeight: isSmallPhone ? '40px' : '50px', marginBottom: isSmallPhone ? '10px' : '0'}}>
    		<Col sm={{span: 1}} />
    		<Col sm={{span: 10}} style={{textAlign: 'center', height: isSmallPhone ? '40px' : '50px', backgroundColor: (props.tipSelect ? '#1E3A8A' : 'black'), color: 'white', borderRadius: '4px', fontSize: isSmallPhone ? '16px' : '18px'}} onClick={props.handleContinueClick} >
          Continue
        </Col>
    		<Col sm={{span: 1}} />
    	</Row>
    </div>
  )
}

export default Tip
